import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "eyeOpened"
const EyeOpenedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0-4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5ZM3.18 12a9.821 9.821 0 0 0 17.64 0 9.821 9.821 0 0 0-17.64 0Z"
      />
    </svg>
  )
}
export default EyeOpenedIcon
